module.exports = __webpack_public_path__ + "img/gamesdk14.766060f.png";